// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"dcec7c9a","605":"4f0b5d47","809":"62452d41","981":"9506ca4a"}[chunkId] + ".chunk.js";
};